export type ClubThemeSettings = {
  mode?: 'light' | 'dark' | null;
  menu_bg_color?: string | null;
  menu_font?: string | null;
  app_font?: string | null;
};

export const applyClubTheme = (theme?: ClubThemeSettings | null) => {
  const mode = String(theme?.mode || 'light').toLowerCase() === 'dark' ? 'dark' : 'light';
  if (mode === 'dark') document.body.classList.add('dark');
  else document.body.classList.remove('dark');

  const menuBg = (theme?.menu_bg_color || '').trim();
  const menuFont = (theme?.menu_font || '').trim();
  const appFont = (theme?.app_font || '').trim();

  if (menuBg) document.documentElement.style.setProperty('--menu-bg-color', menuBg);
  else document.documentElement.style.removeProperty('--menu-bg-color');

  if (menuFont) document.documentElement.style.setProperty('--menu-font', menuFont);
  else document.documentElement.style.removeProperty('--menu-font');

  if (appFont) document.documentElement.style.setProperty('--app-font', appFont);
  else document.documentElement.style.removeProperty('--app-font');
};
